import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

export const privatePagesGuard: CanActivateChildFn = (_, state) =>
  inject(AuthService).isAuthenticated ||
  inject(Router).createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
